@if (isManagedByTruecommand$ | async) {
  <ix-icon name="ix-truecommand-logo-mark-color"></ix-icon>
  <span class="truecommand-text">{{ 'Managed by TrueCommand' | translate }}</span>
}
